define([], function () {
	'use strict';

	/**
	 * ErrorType enum
	 */
	return {
		RECOVERABLE : 'Recoverable',
		NON_RECOVERABLE : 'Non Recoverable'
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/ErrorType.js
// module id = 7
// module chunks = 3